import * as d3 from "d3";

function getLinks(nodes) {
  var links = [];
  nodes.forEach(node => {
    if (node.parent) {
      links.push({
        source: node.parent,
        target: node.id
      });
    }
  });
  return links;
}

function getRadiusForGroup(group) {
  switch (group) {
    case 0:
      return 60;
    case 1:
      return 25;
    case 2:
      return 20;
    default:
      return 18;
  }
}

function panToNodeSmooth(node, svg, zoom, zoomOverride = null) {
  const x = node.x;
  const y = node.y;
  const currentTransform = d3.zoomTransform(svg.current.node());

  console.log("Panning to node: ", node, " with zoom: ", zoomOverride, " and currentTransform: ", currentTransform.k)
  const zoomValue = zoomOverride ? zoomOverride : currentTransform.k;
  panToPositionSmooth(x, y, zoomValue, svg, zoom);
}

function panToPositionSmooth(x, y, zoomValue, svg, zoom) {
  const finalScale = Math.min(zoomValue, 1.4);
  const offsetY = -100;
  const newTransform = d3.zoomIdentity.scale(finalScale).translate(-x, -y + offsetY);

  svg.current.transition()
    .duration(550)
    .call(zoom.current.transform, newTransform);
}

function canNodeBeExpanded(nodeId, data) {
  const node = data.nodes.find(n => n.id === nodeId);
  const children = data.nodes.filter(n => n.parent === nodeId);

  if (children.length === 0) {
    return true;
  }

  if (children.length > 0) {
    const visibleChildren = children.filter(n => n.isVisible !== false);
    if (visibleChildren.length === 0) {
      return true;
    }
  }
  return false;
}

var minSize = 150;
var size = 18;

function getSizeForNode(textLength, groupNumber) {
  if (groupNumber == 0) {
    const textSize = textLength * size;
    return Math.max(textSize + 70, minSize + 70);
  }
  const textSize = textLength * size;
  return Math.max(minSize, textSize);
}

var height = 90;

function getHeightForNode(groupNumber) {

  if (groupNumber == 0) {
    return height + 70;
  }
  return height;

}

function getRoundCornerAmount(groupNumber) {
    if (groupNumber == 0) {
      return 75;
    }
    return 50;
}

function getNodeNameFromId(nodeString, data) {
  if (nodeString === null || nodeString === undefined) {
    return '';
  }

  if (data === null || data === undefined || data.nodes.length === 0) {
    return '';
  }

  const node = data.nodes.find(n => n.id === nodeString);
  if (!node) {
    return '';
  }
  return node.name;
}

function getNodeChain(nodeString, data) {
  if (nodeString === null || nodeString === undefined) {
    return '';
  }

  if (data === null || data === undefined || data.nodes.length === 0) {
    return '';
  }

  const node = data.nodes.find(n => n.id === nodeString);
  if (!node) {
    return '';
  }
  var parents = getParents(node, data);
  parents = parents.reverse();
  parents.push(node);
  var parentString = parents.map(p => p.name).join(':');
  return parentString;
}

const getParents = (node, data) => {
  if (node.group === 0) {
    return [];
  }
  var parent = data.nodes.find(n => n.id === node.parent);
  return [parent, ...getParents(parent, data)];
}


export { getLinks, getRadiusForGroup, panToNodeSmooth, canNodeBeExpanded, getSizeForNode, getNodeNameFromId, getNodeChain, getParents, getHeightForNode, getRoundCornerAmount};
